/**
 * Projects API
 */

import { apiFetch } from './config';
import type { Project, Invariant, PaginatedResponse } from '../types';

export const projectsApi = {
  /**
   * List projects for user's companies
   */
  list: async (): Promise<{ success: boolean; data?: Project[]; error?: string }> => {
    const response = await apiFetch<any>('/api/projects');
    if (response.success && response.data) {
      // Unwrap response envelope: { success, message, data: { Records: [...] }, meta }
      const records = response.data?.data?.Records || response.data?.Records || [];
      return { success: true, data: records };
    }
    return { success: false, error: response.error };
  },

  /**
   * Get single project
   */
  get: async (projectId: string) => {
    return apiFetch<Project>(`/api/projects/${projectId}`);
  },

  /**
   * Create project
   */
  create: async (data: { name: string; description?: string; companyId: string; repoUrl?: string }) => {
    return apiFetch<Project>('/api/projects', {
      method: 'POST',
      body: JSON.stringify({
        project_name: data.name,
        description: data.description,
        Company_ID: data.companyId,
        repo_url: data.repoUrl,
      }),
    });
  },

  /**
   * Update project
   */
  update: async (projectId: string, data: { name?: string; description?: string }) => {
    return apiFetch<Project>('/api/projects', {
      method: 'PUT',
      body: JSON.stringify({
        project_id: projectId,
        project_name: data.name,
        description: data.description,
      }),
    });
  },

  /**
   * Archive project
   */
  archive: async (projectId: string) => {
    return apiFetch<{ message: string }>(`/api/projects?project_id=${encodeURIComponent(projectId)}`, {
      method: 'DELETE',
    });
  },

  /**
   * Get project invariants
   */
  getInvariants: async (projectId: string, page = 1, pageSize = 20) => {
    return apiFetch<PaginatedResponse<Invariant>>(
      `/api/projects/${projectId}/invariants?page=${page}&pageSize=${pageSize}`
    );
  },
};
